import { render, staticRenderFns } from "./SupplierEvaluationBasicInformation.vue?vue&type=template&id=2a1e77a4&scoped=true&"
import script from "./SupplierEvaluationBasicInformation.vue?vue&type=script&lang=js&"
export * from "./SupplierEvaluationBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEvaluationBasicInformation.vue?vue&type=style&index=0&id=2a1e77a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e77a4",
  null
  
)

export default component.exports